module.exports = __webpack_public_path__ + "static/investors-bg-ea7b84891aed156e2164d250c7ac7ac9.jpg";